import type { RequiredGeneric } from '@pba/react-utils';
import { PasswordInput } from 'ui';
import { useNewPasswordRules, usePasswordAsCurrentPasswordRule } from '../hooks';

export type ChangePasswordFormContentValues = {
  currentPassword: string;
  password: string;
};

const ChangePasswordFormContent = <T extends ChangePasswordFormContentValues = never>(_: RequiredGeneric<T>) => {
  const passwordAsCurrentPasswordRule = usePasswordAsCurrentPasswordRule();
  const newPasswordRules = useNewPasswordRules();

  return (
    <>
      <PasswordInput
        item={{
          label: 'Current password',
          name: 'currentPassword',
          rules: [
            {
              required: true,
              whitespace: true,
            },
          ],
        }}
      />

      <PasswordInput
        item={{
          dependencies: ['currentPassword'],
          label: 'New password',
          name: 'password',
          rules: [...newPasswordRules, passwordAsCurrentPasswordRule],
        }}
        showValidation
      />
    </>
  );
};

export default ChangePasswordFormContent;
